import { useDispatch, useSelector } from "react-redux";
import { axiosInstance, handleErrors } from "../auth";
import { saveAs } from "file-saver";
import { CLEAR } from "../list";

export const UPDATE_FIELD = `WizardUpdateField`;
export const SET_TYPE = `WizardSetType`;
export const RESET = `WizardReset`;
export const NEXT = `WizardNext`;
export const PREVIOUS = `WizardPrevious`;
export const SET_STEP = `WizardSetStep`;
export const CHANGE_STATUS = `WizardChangeStatus`;

export const updateFields = ({ prop, value }) => ({
  type: UPDATE_FIELD,
  payload: { prop, value },
});

export const useWizard = () => {
  const wizard = useSelector((state) => state.wizard);
  const dispatch = useDispatch();
  return {
    ...wizard,
    dispatch,
    reset,
    next,
    previous,
    changeType,
    submitBaseInfo,
    getProductInfo,
    submitDetail,
    submitMedia,
    submitCounting,
    changeStep,
    getProductSeasons,
    updateProductSeason,
    submitProductSeason,
    deleteProductSeason,
    submitPhysicalDetail,
    changeStatus,
    updateFields,
  };
};

export const changeStatus = () => async (dispath, getState) => {
  try {
    dispath(updateFields({ prop: "load", value: true }));
    const {
      wizard: { product },
    } = getState();
    const status = product.status == "Draft" ? "Publish" : "Draft";
    let result = await axiosInstance.post(
      `panel/products/${product.id}/status-update`,
      { status }
    );
    dispath(
      updateFields({
        prop: "product",
        value: { ...product, status: result.data.status },
      })
    );
    dispath(updateFields({ prop: "load", value: false }));
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));
    handleErrors(e);
  }
};
export const submitBaseInfo = (data, cb) => async (dispath, getState) => {
  try {
    const {
      wizard: { mode, product },
    } = getState();
    dispath(updateFields({ prop: "load", value: true }));
    let resulat;
    if (mode == "add") {
      resulat = await axiosInstance.post("/products", data);
    } else {
      resulat = await axiosInstance.put(`/products/${product.id}`, data);
    }

    dispath(updateFields({ prop: "load", value: false }));
    dispath(updateFields({ prop: "product", value: resulat.data }));
    dispath(updateFields({ prop: "mode", value: "update" }));
    cb(resulat.data);
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));
    handleErrors(e);
  }
};

export const submitDetail = (data, id, cb) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "load", value: true }));
    const resulat = await axiosInstance.post(`/products/${id}/detail`, data);
    dispath(updateFields({ prop: "load", value: false }));
    dispath(updateFields({ prop: "product", value: resulat.data }));
    cb();
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));

    handleErrors(e);
  }
};
export const submitPhysicalDetail = (data, id, cb) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "load", value: true }));
    const resulat = await axiosInstance.post(
      `/products/${id}/physical-detail`,
      data
    );
    dispath(updateFields({ prop: "load", value: false }));
    dispath(updateFields({ prop: "product", value: resulat.data }));
    cb();
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));
    handleErrors(e);
  }
};

export const submitMedia = (data, id, cb) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "load", value: true }));
    const fd = new FormData();

    for (let dataKey in data) {
      if (dataKey === "subtitles") {
        if (data[dataKey].length < 1) {
          fd.append(`subtitles`, [null]);
          continue;
        }
        // append nested object
        for (let sKey in data[dataKey]) {
          for (let ssKey in data[dataKey][sKey]) {
            if (ssKey == "file" && data[dataKey][sKey]["id"] !== null) continue;
            if (ssKey == "file") {
              fd.append(
                `subtitles[${sKey}][${ssKey}]`,
                data[dataKey][sKey][ssKey].file
              );
            } else {
              fd.append(
                `subtitles[${sKey}][${ssKey}]`,
                data[dataKey][sKey][ssKey]
              );
            }
          }
        }
      } else if (dataKey === "trailers") {
        if (data[dataKey].length < 1) {
          fd.append(`trailers`, [null]);
          continue;
        }
        // append nested object
        for (let tKey in data[dataKey]) {
          for (let ttKey in data[dataKey][tKey])
            fd.append(
              `trailers[${tKey}][${ttKey}]`,
              data[dataKey][tKey][ttKey]
            );
        }
      } else if (dataKey === "reviews") {
        if (data[dataKey].length < 1) {
          fd.append(`reviews`, [null]);
          continue;
        }
        // append nested object
        for (let tKey in data[dataKey]) {
          for (let ttKey in data[dataKey][tKey])
            fd.append(`reviews[${tKey}][${ttKey}]`, data[dataKey][tKey][ttKey]);
        }
      } else if (dataKey === "translates") {
        // append nested object
        for (let tKey in data[dataKey]) {
          for (let ttKey in data[dataKey][tKey])
            fd.append(
              `translates[${tKey}][${ttKey}]`,
              data[dataKey][tKey][ttKey]
            );
        }
      } else {
        fd.append(dataKey, data[dataKey]);
      }
    }

    const resulat = await axiosInstance.post(`/products/${id}/media`, fd);
    dispath(updateFields({ prop: "load", value: false }));
    dispath(updateFields({ prop: "product", value: resulat.data }));
    cb();
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));

    handleErrors(e);
  }
};
export const getProductInfo = (id) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "load", value: true }));
    const resulat = await axiosInstance.get(`/products/${id}`);
    dispath(updateFields({ prop: "product", value: resulat.data }));
    dispath(updateFields({ prop: "mode", value: "update" }));
    dispath(
      updateFields({ prop: "type", value: resulat.data && resulat.data.type })
    );
    dispath(updateFields({ prop: "load", value: false }));
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));

    handleErrors(e);
  }
};

export const submitCounting = (data, id, cb) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "load", value: true }));
    const resulat = await axiosInstance.post(`/products/${id}/counting`, data);
    dispath(updateFields({ prop: "load", value: false }));
    dispath(updateFields({ prop: "product", value: resulat.data }));
    cb();
  } catch (e) {
    dispath(updateFields({ prop: "load", value: false }));

    handleErrors(e);
  }
};

export const getProductSeasons = (id) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "seasonsLoad", value: true }));
    const resulat = await axiosInstance.get(`/products/${id}/seasons`);
    dispath(updateFields({ prop: "seasons", value: resulat.data }));

    dispath(updateFields({ prop: "seasonsLoad", value: false }));
  } catch (e) {
    dispath(updateFields({ prop: "seasonsLoad", value: false }));

    handleErrors(e);
  }
};

export const submitProductSeason = (id, data) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "seasonsLoad", value: true }));
    const resulat = await axiosInstance.post(`/products/${id}/seasons`, data);
    dispath(updateFields({ prop: "seasonsLoad", value: false }));
    dispath(getProductSeasons(id));
  } catch (e) {
    dispath(updateFields({ prop: "seasonsLoad", value: false }));

    handleErrors(e);
  }
};

export const updateProductSeason = (p_id, s_id, data) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "seasonsLoad", value: true }));
    const resulat = await axiosInstance.put(
      `/products/${p_id}/seasons/${s_id}`,
      data
    );
    dispath(updateFields({ prop: "seasonsLoad", value: false }));
    dispath(getProductSeasons(p_id));
  } catch (e) {
    dispath(updateFields({ prop: "seasonsLoad", value: false }));

    handleErrors(e);
  }
};

export const deleteProductSeason = (p_id, s_id) => async (dispath) => {
  try {
    dispath(updateFields({ prop: "seasonsLoad", value: true }));
    const resulat = await axiosInstance.delete(
      `/products/${p_id}/seasons/${s_id}`
    );
    dispath(updateFields({ prop: "seasonsLoad", value: false }));
    dispath(getProductSeasons(p_id));
  } catch (e) {
    dispath(updateFields({ prop: "seasonsLoad", value: false }));

    handleErrors(e);
  }
};

export const changeType = (type) => ({
  type: SET_TYPE,
  payload: { type },
});

export const next = () => ({
  type: NEXT,
  payload: {},
});

export const previous = () => ({
  type: PREVIOUS,
  payload: {},
});
export const changeStep = (step) => ({
  type: SET_STEP,
  payload: { step },
});
export const reset = () => ({
  type: RESET,
  payload: {},
});
